import styled from 'styled-components';

const Container = styled.div`
  border-bottom: 2px solid #4d4d4d;
`;

export { Container };
